/**
 * @author Rejo Varghese
 * @description Sagas related to demand days
 */

import { takeLatest,put,call,all,fork } from 'redux-saga/effects'
import { SET_DEMAND_DAYS, GET_DEMAND_DAYS, INSERT_DEMAND_DAYS } from '../actions/action-types';
import { message } from 'antd';
import { getDemandDaysAction } from '../actions/demand-days.action';
import { currentDate, firstDayOfMonth, lastDayOfMonth, addMonth } from '../utils/dates-util';


export function* getDemandDays(action) {
    try{
        const {api, url, apiPayload} = {...action.payload};
        const apiResult = yield call(api, url, apiPayload);
        if (apiResult.status === "SUCCESS") {
            let clientPayload = apiResult.payload;
            if (clientPayload.Status === "SUCCESS") {
                let serverPayload = clientPayload.Payload;
                yield put ({
                    type: SET_DEMAND_DAYS,
                    payload: serverPayload
                });
            }
            else {
                message.error(clientPayload.Message);
            }
        }
    }
    catch(err) {
        console.error("Error in getting demand days", err);
    }
}

function* watchGetDemandDays () {
    yield takeLatest (GET_DEMAND_DAYS, getDemandDays);
}


export function* insertDemandDaysSaga(action) {
    try{
        const {api, url, apiPayload} = {...action.payload};
        const apiResult = yield call(api, url, apiPayload);
        const today = currentDate();
        const startDate = firstDayOfMonth(today);
        const nextMonth = addMonth(today, 1);
        const endDate = lastDayOfMonth(nextMonth);
        let fetchDemandDays = getDemandDaysAction(apiPayload.originList, apiPayload.destinationList, startDate, endDate);
        if (apiResult.status === "SUCCESS") {
            let clientPayload = apiResult.payload;
            if (clientPayload.Status === "SUCCESS") {
                yield* getDemandDays(fetchDemandDays);
                message.success(clientPayload.Message);
            }
            else {
                message.error(clientPayload.Message);
            }
        }
    }
    catch(err) {
        console.error("Error in getting demand days", err);
    }
}

function* watchinsertDemandDaysSaga () {
    yield takeLatest (INSERT_DEMAND_DAYS, insertDemandDaysSaga);
}

export function*  watchDemandDaysSagas() {
    yield all([
        fork(watchGetDemandDays),
        fork(watchinsertDemandDaysSaga),
    ])
}
